import RadioButton from '../radioButton';
import styles from './style.module.scss';

export type OptionType = {
  displayValue: string;
  actualValue: string | number;
};

interface RadioGroupProps {
  options: OptionType[];
  name: string;
  value?: string | number;
  caption?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  classNames?: string;
  disabled?: boolean;
}

const RadioGroup = (props: RadioGroupProps) => {
  const {
    options,
    name,
    value,
    caption,
    onChange = () => {},
    classNames = '',
    disabled = false,
  } = props;
  return (
    <>
      {caption && (
        <legend
          className={`text-sm md:text-base leading-5 mb-8 ${styles.caption}`}
          data-testid={`${name}-caption`}
        >
          {caption}
        </legend>
      )}
      <fieldset className="grid grid-cols-1 md:grid-cols-3 gap-7" role="radiogroup">
        {options.map((option: OptionType, index) => (
          <RadioButton
            variant="medium"
            key={option.actualValue}
            id={`${name}-${index}`}
            name={name}
            label={option.displayValue}
            className={`md:text-lg ${styles.radio} ${classNames}`}
            onChange={onChange}
            value={option.actualValue}
            defaultChecked={value === option.actualValue}
            disabled={disabled}
            dataTestid={`${name}-${index}`}
          />
        ))}
      </fieldset>
    </>
  );
};

export default RadioGroup;
